export function preventDefaultPropagation(e){
  e.preventDefault()
  e.stopPropagation()
}